export class AddStageModal {

  SaleOrderStages?: string = "";
  OnlyInternal?: boolean = false;
  OnlyCustomer?: boolean = false;
  WhatsAppTemplateMasterId?: number;
}

export class EditStageModal {

  StageId?: number = 0;
  SaleOrderStages?: string = "";
  OnlyInternal?: boolean = false;
  OnlyCustomer?: boolean = false;
  WhatsAppTemplateMasterId?: string = "";
}

export class StagesTableModel {

  SerialNumber?: number = 0;
  StageId?: number = 0;
  SaleOrderStages?: string = ""
  OnlyInternal?: boolean = false;
  OnlyCustomer?: boolean = false;
  AddedBy?: string = "";
  WhatsAppTemplateMasterId?: string = "";
  AddedDate?: string = "";
  Disabled?: boolean = false;
  DisabledBy?: string = "";
  DisabledDate?: string = "";
}


export class NotificationStageModelExport {

  SaleOrderStages?: string = ""
  OnlyInternal?: boolean = false;
  OnlyCustomer?: boolean = false;
  AddedBy?: string = "";
  AddedDate?: string = "";
}

export class NotificationGroupsModelExport {
  NotificationType?: string = "";
  TriggerType?: string | string[] = "";
  ReportName?: string = "";
  UserType?: string = "";
  Name?: string = "";
  Email?: string = "";
  MobileNumber?: String = '';
  IsWhatsAppNotificationEnabled?: boolean = false;
  EnableToEmail?: boolean = false;
  EnableCcemail?: boolean = false;
  EnableBccemail?: boolean = false;
  UserMasterId?: Number = 0;
}

export enum NotificationTriggerType {
  Event = "Event",
  Schedule = "Schedule",
  OnDemand = "OnDemand"
}

// Interface for notification schedule mappings
export interface NotificationReportScheduleMapping {
  ReportId: number;
  ReportType: string;
  ReportName: string;
  NotificationGroupUserId?: number;
  TemplateMasterId?: number;
  CronExpression: string;
  LastRunTime?: string;
  NextRunTime?: string;
  IsActive: boolean;
  TimeZone: string;
  AddedBy: string;
  AddedDate?: string;
  Disabled: boolean;
  DisabledBy?: number;
  DisabledDate?: string;
  isUpdating?: boolean; // Added for UI loading state
}

export class NotificationGroups {
  SerialNumber?: number = 0;
  NotificationGroupUserId?: number = 0;
  CronScheduleExpression: string = "";
  NotificationType?: string = "";
  TriggerType?: string[] | string = ""; // Can be array or string for backward compatibility
  ReportName?: string = ""; // Added for report name selection
  ScheduleFrequency?: string = ""; // Daily, Weekly, Monthly
  ScheduleTime?: string = ""; // Time of day for scheduled notifications
  IsReminderScheduleRequired?: boolean = false;
  IsReminderScheduleAllowed?: boolean = false;
  Name?: string = "";
  Email?: string = "";
  UserType?: string = "";
  UserMasterId?: Number = 0;
  IsWhatsAppNotificationEnabled?: boolean = false;
  IsPushNotificationEnabled?: boolean = false;
  WhatsAppTemplateMasterId?: number = 0;
  MobileNumber?: String = '';
  EnableToEmail?: boolean = false;
  EnableCcemail?: boolean = false;
  EnableBccemail?: boolean = false;
  AddedBy?: string = '';
  AddedDate?: string = '';
  Disabled?: boolean = false;
  DisabledBy?: string = "";
  DateTime?: string = "";
  LastTriggeredBy?: string = ""; // For on-demand notifications
  LastTriggeredDate?: string = ""; // For on-demand notifications
  EmailGroupMappings?: any = [];
  NotificationReportScheduleMappings?: NotificationReportScheduleMapping[] = []; // Added for schedule management

  // NEW FIELD - Configuration mapping for hierarchical dropdown system
  ConfigurationId?: number = 0;
}



export class AddNotificationGroups {
  NotificationType?: string = "";
  TriggerType?: string[] | string = ""; // Can be array or string for backward compatibility
  ReportName?: string = ""; // Added for report name selection
  CronScheduleExpression?: string = "";
  ScheduleFrequency?: string = ""; // Daily, Weekly, Monthly
  ScheduleTime?: string = ""; // Time of day for scheduled notifications
  Name?: string = "";
  Email?: string = "";
  UserType?: string = "";
  UserMasterId?: Number = 0;
  IsWhatsAppNotificationEnabled?: boolean = false;
  IsPushNotificationEnabled?: boolean = false;
  MobileNumber?: String = '';
  EnableToEmail?: boolean = false;
  EnableCcemail?: boolean = false;
  EnableBccemail?: boolean = false;
  AddedBy?: string = '';
  AddedDate?: string = '';
  Disabled?: boolean = false;
  DisabledBy?: string = "";
  DateTime?: string = "";
  LastTriggeredBy?: string = ""; // For on-demand notifications
  LastTriggeredDate?: string = ""; // For on-demand notifications
  EmailGroupMappings = [];

  // NEW FIELD - Configuration mapping for hierarchical dropdown system
  ConfigurationId?: number = 0;
}

export class EmailGroupMappingList {
  SerialNumber?: number = 0;
  EmailGroupMappingId?: number = 0;
  NotificationGroupUserId?: number = 0;
  NotificationGroupUserName?: string = "";
  StageId?: number = 0;
  StageName?: string = "";
  Enabled?: boolean = false;
  AddedBy?: string = "";
  AddedDate?: string = "";
  Disabled?: boolean = false;
  DisabledBy?: string = "";
  DisabledDate?: string = "";
}

export class AddEmailGroupMapping {
  NotificationGroupUserId?: number = 0
  StageId?: number = 0
  Enabled?: boolean = false;
  AddedBy?: string = "";
  AddedDate?: string = "";
  Disabled?: boolean = false;
  DisabledBy?: string = "";
  DisabledDate?: string = "";
}

export class EmailGroupMappingModelExport {
  StageName?: string = "";
  NotificationGroupUserName?: string = "";
  Enabled?: boolean = false;
  AddedBy?: string = "";
  AddedDate?: string = "";
}

// Whatsapp Template

export class WhatsAppTemplateList {
  SerialNumber?: number = 0;
  ExpandRecord?: boolean = false;
  WhatsAppTemplateMasterId?: number = 0;
  ProviderName?: string = "";
  ProviderTemplateId?: number = 0;
  ProviderTemplateName?: string = "";
  ProviderTemplateDescription?: string = "";
  TemplateType?: string = "Text";
  InteractiveMetadataJson?: string = "";
  TypeOfVariable?: string = "Number";
  Parameters?: AddWhatsAppTemplateParameter[] = [];
  AddedBy?: string = "";
  AddedDate?: string = "";
  Disabled?: boolean = false;
  DisabledBy?: string = "";
  DisabledDate?: string = "";
}
export class AddWhatsAppTemplate {

  WhatsAppTemplateMasterId?: number = 0;
  ProviderName?: string = "";
  ProviderTemplateId?: number = 0;
  ProviderTemplateName?: string = "";
  ProviderTemplateDescription?: string = "";
  TemplateType?: string = "Text";
  InteractiveMetadataJson?: string = "";
  TypeOfVariable?: string = "Number";
  AddedBy?: string = "";
  AddedDate?: string = "";
  Disabled?: boolean = false;
  DisabledBy?: string = "";
  DisabledDate?: string = "";
}

export class AddWhatsAppTemplateParameter {
  ParameterId?: number = 0;
  TemplateMasterId?: number = 0;
  ParameterName?: string = "";
  ParameterType?: string = "";
  IsRequired?: boolean = false;
  DefaultValue?: string = "";
  Sequence?: number = 0;
}

export class WhatsAppTemplateExport {
  ProviderName?: string = "";
  ProviderTemplateName?: string = "";
  ProviderTemplateDescription?: string = "";
  TemplateType?: string = "Text";
  TypeOfVariable?: string = "Number";
  AddedBy?: string = "";
  AddedDate?: string = "";
}


// public class Whats App Config
export class WhatsAppConfigList {
  SerialNumber?: number = 0;
  WhatsAppConfigId?: number = 0;
  ConfigName?: string = "";
  ProviderName?: string = "";
  RegisteredSenderNumber?: string = "";
  ProviderKey?: string = "";
  MaxDailyMessages?: number = 0;
  MaxMonthlyMessages?: number = 0;
  ApiEndpoint?: string = "";
  WebhookUrl?: string = "";
  WebhookSecret?: string = "";
  WebhookVerifyToken?: string = "";
  AddedBy?: string = "";
  AddedDate?: string = "";
  Disabled?: boolean = false;
  DisabledBy?: string = "";
  DisabledDate?: string = "";
}

export class AddWhatsAppConfig {

  WhatsAppConfigId?: number = 0;
  ConfigName?: string = "";
  ProviderName?: string = "";
  RegisteredSenderNumber?: string = "";
  ProviderKey?: string = "";
  MaxDailyMessages?: number = 0;
  MaxMonthlyMessages?: number = 0;
  ApiEndpoint?: string = "";
  WebhookUrl?: string = "";
  WebhookSecret?: string = "";
  WebhookVerifyToken?: string = "";
  AddedBy?: string = "";
  AddedDate?: string = "";
  Disabled?: boolean = false;
  DisabledBy?: string = "";
  DisabledDate?: string = "";
}

export class WhatsAppConfigExport {
  ConfigName?: string = "";
  ProviderName?: string = "";
  RegisteredSenderNumber?: string = "";
  ProviderKey?: string = "";
  AddedBy?: string = "";
  AddedDate?: string = "";
}

// Detailed view models for comprehensive notification group information
export class NotificationGroupDetails {
  // Basic notification group information
  NotificationGroupUserId?: number = 0;
  NotificationType?: string = "";
  Name?: string = "";
  Email?: string = "";
  UserType?: string = "";
  UserMasterId?: number = 0;
  ReportName?: string = "";
  TriggerType?: string[] = [];
  AddedBy?: string = "";
  AddedDate?: Date = null;
  LastTriggeredDate?: Date = null;
  LastTriggeredBy?: string = "";

  // WhatsApp configuration details
  IsWhatsAppNotificationEnabled?: boolean = false;
  WhatsAppTemplateMasterId?: number = 0;

  // Push notification
  IsPushNotificationEnabled?: boolean = false;
  MobileNumber?: string = "";
  WhatsAppTemplate?: WhatsAppTemplateDetails = null;
  WhatsAppConfig?: WhatsAppConfigDetails = null;

  // Email configuration details
  EnableToEmail?: boolean = false;
  EnableCcemail?: boolean = false;
  EnableBccemail?: boolean = false;
  EmailConfig?: EmailConfigDetails = null;

  // Related mappings and schedules
  EmailGroupMappings?: EmailGroupMappingDetails[] = [];
  NotificationReportScheduleMappings?: NotificationReportScheduleMappingDetails[] = [];

  // Status information
  Disabled?: boolean = false;
  DisabledBy?: string = "";
  DisabledDate?: Date = null;
}

export class WhatsAppTemplateDetails {
  WhatsAppTemplateMasterId?: number = 0;
  ProviderName?: string = "";
  ProviderTemplateId?: string = "";
  ProviderTemplateName?: string = "";
  ProviderTemplateDescription?: string = "";
  Parameters?: NotificationTemplateParameter[] = [];
}

// New models for NotificationTemplateConfiguration
export class NotificationTemplateConfiguration {
  ConfigurationId?: number = 0;
  CategoryType?: string = "";        // Level 1: Business Domain (Inventory, Production, Costing)
  NotificationType?: string = "";    // Level 2: Business Function (Low Stock, Order Status, Reports)
  SubType?: string = "";             // Level 3: Specific Implementation (LowStockReport, YieldSummaryReport)
  DisplayName?: string = "";
  Description?: string = "";
  InternalAllowed?: boolean = true;
  ExternalAllowed?: boolean = false;
  CustomerAllowed?: boolean = false;
  EventAllowed?: boolean = true;
  SchedulingAllowed?: boolean = false;
  OnDemandAllowed?: boolean = true;
  SchedulingRequired?: boolean = false;
  WhatsAppTemplateMasterId?: number = null;
  EmailTemplateMasterId?: number = null;
  PushNotificationAllowed?: boolean = false;
  PushPriorityLevel?: string = 'normal';
  RequiresAcknowledgement?: boolean = false;
  ExpiryDurationHours?: number = null;
  SortOrder?: number = 0;
  IsDefault?: boolean = false;
  // Config-level schedule (the WHEN) for scheduling-allowed types. Persisted as a
  // shared NotificationReportScheduleMappingTable row (NotificationGroupUserId NULL).
  CronExpression?: string = "";
  ScheduleTimeZone?: string = "";
  ScheduleActive?: boolean = false;
  AddedById?: number = null;
  AddedDate?: string = "";
  UpdatedById?: number = null;
  UpdatedDate?: string = "";
  Disabled?: boolean = false;
  DisabledById?: number = null;
  DisabledDate?: string = "";

  // Display properties
  AddedBy?: string = "";
  UpdatedBy?: string = "";
  DisabledBy?: string = "";
  WhatsAppTemplateName?: string = "";
  SerialNumber?: number = 0;
}

export class NotificationTypeList {
  ConfigurationId?: number = 0;
  CategoryType?: string = "";        // Level 1: Business Domain (Inventory, Production, Costing)
  NotificationType?: string = "";    // Level 2: Business Function (Low Stock, Order Status, Reports)
  SubType?: string = "";             // Level 3: Specific Implementation (LowStockReport, YieldSummaryReport)
  DisplayName?: string = "";
  InternalAllowed?: boolean = true;
  ExternalAllowed?: boolean = false;
  CustomerAllowed?: boolean = false;
  EventAllowed?: boolean = true;
  SchedulingAllowed?: boolean = false;
  OnDemandAllowed?: boolean = true;
  SchedulingRequired?: boolean = false;
  WhatsAppTemplateMasterId?: number = null;
  EmailTemplateMasterId?: number = null;
  PushNotificationAllowed?: boolean = false;
  PushPriorityLevel?: string = 'normal';
  RequiresAcknowledgement?: boolean = false;
  ExpiryDurationHours?: number = null;
  SortOrder?: number = 0;
  IsDefault?: boolean = false;
}

// Hierarchical dropdown models for cascading selection
export class CategoryTypeOption {
  value?: string = "";
  name?: string = "";
  description?: string = "";
}

export class NotificationTypeOption {
  value?: string = "";
  name?: string = "";
  categoryType?: string = "";
  description?: string = "";
  isReportsType?: boolean = false;
  // Trigger capabilities
  EventAllowed?: boolean = true;
  SchedulingAllowed?: boolean = false;
  OnDemandAllowed?: boolean = true;
  IsReminderScheduleAllowed?: boolean = false;
  // Permission flags
  InternalAllowed?: boolean = true;
  ExternalAllowed?: boolean = false;
  CustomerAllowed?: boolean = false;
}

export class SubTypeOption {
  value?: string = "";
  name?: string = "";
  categoryType?: string = "";
  notificationType?: string = "";
  description?: string = "";
}

// Export model for notification template configuration
export class NotificationTemplateConfigurationExport {
  CategoryType?: string = "";        // Level 1: Business Domain (Inventory, Production, Costing)
  NotificationType?: string = "";    // Level 2: Business Function (Low Stock, Order Status, Reports)
  SubType?: string = "";             // Level 3: Specific Implementation (LowStockReport, YieldSummaryReport)
  DisplayName?: string = "";
  Description?: string = "";
  InternalAllowed?: string = "";
  ExternalAllowed?: string = "";
  CustomerAllowed?: string = "";
  EventAllowed?: string = "";
  SchedulingAllowed?: string = "";
  OnDemandAllowed?: string = "";
  SchedulingRequired?: string = "";
  WhatsAppTemplateName?: string = "";
  AddedBy?: string = "";
  AddedDate?: string = "";
}

export class WhatsAppConfigDetails {
  WhatsAppConfigId?: number = 0;
  ConfigName?: string = "";
  ProviderName?: string = "";
  RegisteredSenderNumber?: string = "";
  ApiEndpoint?: string = "";
  MaxDailyMessages?: number = 0;
  MaxMonthlyMessages?: number = 0;
}

export class EmailConfigDetails {
  EmailConfigId?: number = 0;
  EmailConfigName?: string = "";
  EmailConfigSmtp?: string = "";
  EmailConfigFromEmailId?: string = "";
  EmailConfigFromEmailDisplayName?: string = "";
  EmailConfigPort?: number = 0;
}

export class EmailGroupMappingDetails {
  EmailGroupMappingId?: number = 0;
  NotificationGroupUserId?: number = 0;
  StageId?: number = 0;
  StageName?: string = "";
  Enabled?: boolean = false;
  OnlyInternal?: boolean = false;
  OnlyCustomer?: boolean = false;
  AddedBy?: string = "";
  AddedDate?: Date = null;
  Disabled?: boolean = false;
  DisabledBy?: string = "";
  DisabledDate?: Date = null;
}

export class NotificationReportScheduleMappingDetails {
  ReportId?: number = 0;
  ReportType?: string = "";
  ReportName?: string = "";
  NotificationGroupUserId?: number = 0;
  TemplateMasterId?: number = 0;
  TemplateName?: string = "";
  CronExpression?: string = "";
  LastRunTime?: Date = null;
  NextRunTime?: Date = null;
  IsActive?: boolean = false;
  TimeZone?: string = "";
  AddedBy?: string = "";
  AddedDate?: Date = null;
  Disabled?: boolean = false;
  DisabledBy?: number = 0;
  DisabledDate?: Date = null;
  isUpdating?: boolean = false; // For UI loading state
}

export class NotificationTemplateParameter {
  ParameterId?: number = 0;
  TemplateMasterId?: number = 0;
  ParameterName?: string = "";
  ParameterType?: string = "";
  IsRequired?: boolean = false;
  DefaultValue?: string = "";
  ValidationRegex?: string = "";
  Sequence?: number = 0;
}

// Broadcast push notification models
export class BroadcastPushNotificationRequest {
  UserMasterIds: number[] = [];
  Title: string = "";
  Body: string = "";
  MessageType: string = "Alert";
  Priority: string = "normal";
  RequiresAcknowledgement: boolean = false;
  ExpiryDurationHours?: number = null;
}

export class PushEnabledUser {
  UserId: number = 0;
  Name: string = "";
}